<div class="">
      <app-back-button></app-back-button>

  <!-- HEADER -->
  <div class="flex items-center justify-between mb-6">

    <div>

      <h2 class="text-2xl font-bold text-[#0B0D5C]">
        {{ 'SETUP.DOCUMENTS.TYPES_TITLE' | translate }}
      </h2>

      <p class="text-sm text-gray-500 mt-1">
        {{ 'SETUP.DOCUMENTS.MANAGE_TYPES' | translate }}
      </p>

    </div>

    <button
      (click)="openPopup()"
      class="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-3 rounded-xl text-sm font-semibold transition-all"
    >

      <span>+</span>

      <span>{{ 'SETUP.DOCUMENTS.ADD_DOCUMENT' | translate }}</span>

    </button>

  </div>

  <!-- TABLE -->
  <div class="">

    <app-table
      [columns]="columns"
      [data]="list"
      [actions]="actions"
      [enablePagination]="true"
      [pageSize]="10"
    >
    </app-table>

  </div>

</div>

<!-- ADD / EDIT POPUP -->

<app-popup
  [(show)]="showPopup"
  [title]="
    isEditMode
      ? 'SETUP.DOCUMENTS.EDIT_DOCUMENT'
      : 'SETUP.DOCUMENTS.ADD_DOCUMENT'
  "
  [type]="'form'"
  [fields]="fields"
  [data]="formData"
  [onSave]="handleSave"
  (formChange)="onFormChange($event)"
  width="w-full max-w-2xl"
>
</app-popup>

<!-- DELETE POPUP -->

<app-popup
  [(show)]="showDeletePopup"
  title="SETUP.DOCUMENTS.DELETE_DOCUMENT"
  type="confirm"
  width="w-full max-w-md"
  message="SETUP.DOCUMENTS.DELETE_CONFIRM"
  confirmText="COMMON.DELETE"
  cancelText="COMMON.CANCEL"
  (confirmed)="confirmDelete()"
>
</app-popup>